import { c as _c } from "react/compiler-runtime";
import { useBuilder } from '../../store/provider';
import type { ViewMode } from '../../store/types';
import UndoRedo from './undo-redo';
type UndoRedoContainerProps = {
  viewMode: ViewMode;
};
const UndoRedoContainer = t0 => {
  const $ = _c(7);
  const {
    viewMode
  } = t0;
  const {
    state,
    actions,
    isSavingGraph,
    isReadOnly
  } = useBuilder();
  const t1 = isSavingGraph || isReadOnly;
  let t2;
  if ($[0] !== actions.redo || $[1] !== actions.undo || $[2] !== state.history.next || $[3] !== state.history.previous || $[4] !== t1 || $[5] !== viewMode) {
    t2 = <UndoRedo previous={state.history.previous} next={state.history.next} onUndo={actions.undo} onRedo={actions.redo} disabled={t1} viewMode={viewMode} />;
    $[0] = actions.redo;
    $[1] = actions.undo;
    $[2] = state.history.next;
    $[3] = state.history.previous;
    $[4] = t1;
    $[5] = viewMode;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default UndoRedoContainer;